import "rxjs/add/operator/map";
import {
    MUTATE_OPERATION_ENHANCED,
    WHITEBOARD_HISTORY_REDO,
    WHITEBOARD_HISTORY_UNDO,
    // WHITEBOARD_PAGE_FETCH,
    WHITEBOARD_PAGE_FETCH_COMPLETED,
    // WHITEBOARD_PAGE_REMOVE,
    // WHITEBOARD_PAGES_CREATE,
} from "constants/action-types";
import { history as historyActions, pages as pagesActions } from "actions/whiteboard";
import { mutateOperation } from "actions/mutate";
import { Observable } from "rxjs";

const { pageHistoryFetch } = pagesActions;

export const historyPushEpic = (action$, store) => {
    return action$
        .ofType(MUTATE_OPERATION_ENHANCED)
        .filter(({ payload, meta = {} }) => {
            return payload.HEAD.namespace === "nuorder.service.board" && (meta as any).history !== false;
        })
        .map(({ payload }) => {
            return historyActions.push(payload);
        });
};

export const historyUndo = (action$, store) => {
    return action$
        .ofType(WHITEBOARD_HISTORY_UNDO)
        .map(({ payload }) => {
            const { whiteboard, mutate } = store.getState();
            let { redo, undo } = whiteboard;
            const history = undo.last();
            if (!history) {
                return { history };
            }
            undo = undo.pop();
            redo = redo.push(history);
            return { history, redo, undo, whiteboard, mutate };
        })
        .filter(({ history }) => {
            return !!history;
        })
        .flatMap(({ history, redo, undo, whiteboard, mutate }) => {
            const actions = [
                historyActions.update(undo, redo),
                mutateOperation(history.down.mutableType, history.down.objectId, history.down.operations, {
                    history: false,
                }),
            ];
            const snapshot = mutate.snapshots.get(whiteboard.pagesId);

            if (
                // if undo occurs on different page, trigger a page fetch,
                // navigate to that page, and then perform the undo action
                whiteboard.currentPageId !== history.objectId &&
                // some operations occur on the board (e.g. changing the board name)
                // so don't fetch page if that happens (will erroneously pass boardId to page epic)
                whiteboard.boardId !== history.objectId &&
                // don't do this if the action is adding/deleting a page
                history.mutableType !== "LIST"
            ) {
                // this will block the actions above and run them in the historyPageFetchCompleted epic
                return Observable.of(pageHistoryFetch({ action: "undo", history, undo, redo }, history.objectId));
            }

            if (
                // undoing a page create of the current page
                history.mutableType === "LIST" &&
                history.up.operations[0].operation === "insert" &&
                history.down.operations[0].operation === "remove" &&
                history.up.operations[0].value &&
                history.up.operations[0].value.getIn(["ref", "object_id"]) === whiteboard.currentPageId
            ) {
                const index = snapshot.findIndex(
                    (value) => value.getIn(["ref", "object_id"]) === whiteboard.currentPageId,
                );

                actions.push(
                    pagesActions.current.set(
                        snapshot.get(snapshot.size === index + 1 ? index - 1 : index + 1).getIn(["ref", "object_id"]),
                    ),
                );
            }

            return actions;
        });
};

export const historyRedo = (action$, store) => {
    return action$
        .ofType(WHITEBOARD_HISTORY_REDO)
        .map(({ payload }) => {
            const { whiteboard, mutate } = store.getState();
            let { redo, undo } = whiteboard;
            const history = redo.last();
            if (!history) {
                return { history };
            }
            redo = redo.pop();
            undo = undo.push(history);
            return { history, redo, undo, whiteboard, mutate };
        })
        .filter(({ history }) => {
            return !!history;
        })
        .flatMap(({ history, redo, undo, whiteboard, mutate }) => {
            const actions = [
                historyActions.update(undo, redo),
                mutateOperation(history.up.mutableType, history.up.objectId, history.up.operations, { history: false }),
            ];
            const snapshot = mutate.snapshots.get(whiteboard.pagesId);

            if (
                // if redo occurs on different page, trigger a page fetch,
                // navigate to that page, and then perform the redo action
                whiteboard.currentPageId !== history.objectId &&
                // some operations occur on the board (e.g. changing the board name)
                // so don't fetch page if that happens (will erroneously pass boardId to page epic)
                whiteboard.boardId !== history.objectId &&
                // don't do this if the action is adding/deleting a page
                history.mutableType !== "LIST"
            ) {
                // this will block the actions above and run them in historyPageFetchCompleted epic
                return Observable.of(pageHistoryFetch({ action: "redo", history, undo, redo }, history.objectId));
            }

            if (
                // redoing a page delete of the current page
                history.mutableType === "LIST" &&
                history.up.operation === "remove" &&
                history.down.operation === "insert" &&
                history.down.value &&
                history.down.value.getIn(["ref", "object_id"]) === whiteboard.currentPageId
            ) {
                const index = snapshot.findIndex(
                    (value) => value.getIn(["ref", "object_id"]) === whiteboard.currentPageId,
                );

                actions.push(
                    pagesActions.current.set(
                        snapshot.get(snapshot.size === index + 1 ? index - 1 : index + 1).getIn(["ref", "object_id"]),
                    ),
                );
            }

            return actions;
        });
};

export const historyPageFetchCompleted = (action$, store) =>
    action$
        .ofType(WHITEBOARD_PAGE_FETCH_COMPLETED)
        .filter(({ meta }) => meta && meta.action)
        .flatMap(({ meta }) => {
            const { action, history, redo, undo } = meta;

            switch (action) {
                case "undo":
                    return [
                        historyActions.update(undo, redo),
                        mutateOperation(history.down.mutableType, history.down.objectId, history.down.operations, {
                            history: false,
                        }),
                    ];
                case "redo":
                    return [
                        historyActions.update(undo, redo),
                        mutateOperation(history.up.mutableType, history.up.objectId, history.up.operations, {
                            history: false,
                        }),
                    ];
                default:
            }
        });
